import { Deserializable } from './deserializable.model';

enum Days {
   Sunday = 'sunday',
   Monday = 'monday',
   Tuesday = 'tuesday',
   Wednesday = 'wednesday',
   Thursday = 'thursday',
   Friday = 'friday',
   Saturday = 'saturday',
}

const daysNum = [ Days.Sunday, Days.Monday, Days.Tuesday, Days.Wednesday,
                  Days.Thursday, Days.Friday, Days.Saturday ];

export class Day implements Deserializable {
   public asString = Days.Sunday;
   public asNumber = 0;

   public deserialize(input: string|number): this;
   deserialize(input: string|number): this {
      if (typeof input === 'string') {
         const cap = input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
         this.asString = Days[cap];
         this.asNumber = daysNum.findIndex(v => v === this.asString);
      } else {
         this.asString = daysNum[input];
         this.asNumber = input;
      }
      return this;
   }
}
